import {
  IPlaidCreateLinkTokenParams,
  IPlaidExchangeParams,
  IPlaidPromoteAccountParams,
} from '@common/interfaces/plaid'
import { IApi } from '../../api'
import { createAction } from '../types'

export const prefix = 'plaid'

export const CREATE_LINK_TOKEN_REQUEST = `${prefix}/CREATE_LINK_TOKEN_REQUEST`
export const CREATE_LINK_TOKEN_SUCCESS = `${prefix}/CREATE_LINK_TOKEN_SUCCESS`
export const CREATE_LINK_TOKEN_FAILURE = `${prefix}/CREATE_LINK_TOKEN_FAILURE`

export const createLinkToken = createAction((data: IPlaidCreateLinkTokenParams) => ({
  type: [CREATE_LINK_TOKEN_REQUEST, CREATE_LINK_TOKEN_SUCCESS, CREATE_LINK_TOKEN_FAILURE],
  promise: (api: IApi) => api.plaid.createLinkToken(data),
}))

export const EXCHANGE_REQUEST = `${prefix}/EXCHANGE_REQUEST`
export const EXCHANGE_SUCCESS = `${prefix}/EXCHANGE_SUCCESS`
export const EXCHANGE_FAILURE = `${prefix}/EXCHANGE_FAILURE`

export const exchangePublicToken = createAction((data: IPlaidExchangeParams) => ({
  type: [EXCHANGE_REQUEST, EXCHANGE_SUCCESS, EXCHANGE_FAILURE],
  promise: (api: IApi) => api.plaid.exchangePublicToken(data),
}))

export const LIST_ITEMS_REQUEST = `${prefix}/LIST_ITEMS_REQUEST`
export const LIST_ITEMS_SUCCESS = `${prefix}/LIST_ITEMS_SUCCESS`
export const LIST_ITEMS_FAILURE = `${prefix}/LIST_ITEMS_FAILURE`

export const listItems = createAction((clientId: string) => ({
  type: [LIST_ITEMS_REQUEST, LIST_ITEMS_SUCCESS, LIST_ITEMS_FAILURE],
  promise: (api: IApi) => api.plaid.listItems({ clientId }),
}))

export const LIST_ACCOUNTS_REQUEST = `${prefix}/LIST_ACCOUNTS_REQUEST`
export const LIST_ACCOUNTS_SUCCESS = `${prefix}/LIST_ACCOUNTS_SUCCESS`
export const LIST_ACCOUNTS_FAILURE = `${prefix}/LIST_ACCOUNTS_FAILURE`

export const listAccounts = createAction((plaidItemId: string) => ({
  type: [LIST_ACCOUNTS_REQUEST, LIST_ACCOUNTS_SUCCESS, LIST_ACCOUNTS_FAILURE],
  promise: (api: IApi) => api.plaid.listAccounts(plaidItemId),
}))

export const LIST_BALANCE_HISTORY_REQUEST = `${prefix}/LIST_BALANCE_HISTORY_REQUEST`
export const LIST_BALANCE_HISTORY_SUCCESS = `${prefix}/LIST_BALANCE_HISTORY_SUCCESS`
export const LIST_BALANCE_HISTORY_FAILURE = `${prefix}/LIST_BALANCE_HISTORY_FAILURE`

export const listAccountBalanceHistory = createAction((clientId: string) => ({
  type: [LIST_BALANCE_HISTORY_REQUEST, LIST_BALANCE_HISTORY_SUCCESS, LIST_BALANCE_HISTORY_FAILURE],
  promise: (api: IApi) => api.plaid.listAccountBalanceHistory(clientId),
}))

export const PROMOTE_REQUEST = `${prefix}/PROMOTE_REQUEST`
export const PROMOTE_SUCCESS = `${prefix}/PROMOTE_SUCCESS`
export const PROMOTE_FAILURE = `${prefix}/PROMOTE_FAILURE`

export const promoteAccount = createAction(
  (plaidAccountId: string, data: IPlaidPromoteAccountParams) => ({
    type: [PROMOTE_REQUEST, PROMOTE_SUCCESS, PROMOTE_FAILURE],
    promise: (api: IApi) => api.plaid.promoteAccount(plaidAccountId, data),
  }),
)

export const REMOVE_REQUEST = `${prefix}/REMOVE_REQUEST`
export const REMOVE_SUCCESS = `${prefix}/REMOVE_SUCCESS`
export const REMOVE_FAILURE = `${prefix}/REMOVE_FAILURE`

export const removeItem = createAction((plaidItemId: string) => ({
  type: [REMOVE_REQUEST, REMOVE_SUCCESS, REMOVE_FAILURE],
  promise: (api: IApi) => api.plaid.removeItem(plaidItemId),
}))

export const MANUAL_SYNC_REQUEST = `${prefix}/MANUAL_SYNC_REQUEST`
export const MANUAL_SYNC_SUCCESS = `${prefix}/MANUAL_SYNC_SUCCESS`
export const MANUAL_SYNC_FAILURE = `${prefix}/MANUAL_SYNC_FAILURE`

export const manualSync = createAction((plaidItemId: string, sinceDate?: string) => ({
  type: [MANUAL_SYNC_REQUEST, MANUAL_SYNC_SUCCESS, MANUAL_SYNC_FAILURE],
  promise: (api: IApi) => api.plaid.manualSync(plaidItemId, sinceDate),
}))
